import { render, staticRenderFns } from "./AbsenceDuration.vue?vue&type=template&id=da8b2508&"
import script from "./AbsenceDuration.vue?vue&type=script&lang=js&"
export * from "./AbsenceDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports